/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-12-07 19:32:46
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-09-05 18:06:56
 */
import request from '@/utils/request'
import type { CommonRes, IGetTeamResponse } from '@/typings'

/**
 * 团队管理
 */
interface IGetTeamListRequest {
  page?: number
  size?: number
  is_hide_option?: number
}
// 团队列表
export async function getTeam(params: IGetTeamListRequest) {
  return request<CommonRes<IGetTeamResponse>>('/api/v2/system/team_list', {
    method: 'get',
    params
  })
}

// 团队管理列表
export async function getTeamList(params: any) {
  return request('/api/v2/system/team_tree', {
    method: 'GET',
    params
  })
}

// 新建/编辑 团队管理
export async function createTeam(params: any) {
  return request('/api/v2/system/team_save', {
    method: 'POST',
    data: params
  })
}

// 团队管理删除
export async function deleteTeam(params: any) {
  return request('/api/v2/system/team_delete', {
    method: 'POST',
    data: params
  })
}

/**
 * 成员管理
 */

// 团队成员列表
export async function getTeamMembersList(params: any) {
  return request('/api/v2/system/team_member_search', {
    method: 'GET',
    params
  })
}

// 新建团队成员
export async function createTeamMember(params: any) {
  return request('/api/v2/system/team_member_save', {
    method: 'POST',
    data: params
  })
}

// 团队成员删除
export async function deleteTeamMember(params: any) {
  return request('/api/v2/system/team_member_delete', {
    method: 'POST',
    data: params
  })
}

interface IGetTeamAllRequest {
  is_need_non_team?: number
  is_hide_option?: number // 是否需要选项隐藏
}
// 项目 - 获取全部团队成员，包括财务后台等未分配人员
export async function getTeamAll(params: IGetTeamAllRequest) {
  return request('/api/v2/system/team_list_all', {
    method: 'get',
    data: params
  })
}

interface IGetUserLeaderRequest {
  user_id?: number
}
// 项目 - 获取成员所在团队负责人
export async function getUserLeader(params: IGetUserLeaderRequest) {
  return request('/api/v2/system/team_leader_account_list_by_user_id', {
    method: 'get',
    data: params
  })
}
